import { useEffect, useState } from "react";
import { mailbox, MAILBOX_CHANGED_EVENT } from "../../api/mailbox";

// 側邊欄「信箱」旁的收件匣未讀數(規格 §2.4「新信通知」)。
//
// **不輪詢。** 同步服務收到新信會走既有的通知推播(SSE),`useNotifications` 收到推播時
// 廣播 `nq-live`,這裡聽到就重問一次;信箱頁自己讀了 / 刪了信則廣播 `MAILBOX_CHANGED_EVENT`。
// 不走 react-query 的理由與 `useUnreadUpdates` 相同:側邊欄幾乎每支元件測試都會掛。
// 讀不到(沒啟用、後端掛了)就是 0 —— 紅點畫錯比不畫糟。

/** `useNotifications` 收到推播時廣播的事件名。 */
export const LIVE_EVENT = "nq-live";

export function useMailboxUnread(): number {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let alive = true;
    const load = () => {
      mailbox
        .unread()
        .then((got) => {
          if (alive) setCount(Math.max(0, Number(got?.inbox_unread) || 0));
        })
        .catch(() => {
          if (alive) setCount(0);
        });
    };
    load();
    window.addEventListener(LIVE_EVENT, load);
    window.addEventListener(MAILBOX_CHANGED_EVENT, load);
    return () => {
      alive = false;
      window.removeEventListener(LIVE_EVENT, load);
      window.removeEventListener(MAILBOX_CHANGED_EVENT, load);
    };
  }, []);
  return count;
}
